import { render, staticRenderFns } from "./RightMenu.vue?vue&type=template&id=9dd54164&scoped=true"
import script from "./RightMenu.vue?vue&type=script&lang=js"
export * from "./RightMenu.vue?vue&type=script&lang=js"
import style0 from "./RightMenu.vue?vue&type=style&index=0&id=9dd54164&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd54164",
  null
  
)

export default component.exports